import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Input, TextArea } from '@driftt/tide'
import DriftHelpDomainInput from 'components/Settings/DriftHelpDomainInput'
import CustomLinks from './CustomLinks'
import { bindActionCreators } from 'redux'

import * as selectors from 'modules/settings/selectors'
import * as actions from 'modules/settings/actions'

import './style.css'

class BasicSettings extends Component {
  
  handleTitleChange = event => this.props.setTitle(event.target.value)
  
  handleTaglineChange = event => this.props.setTagline(event.target.value)
  
  handleDescriptionChange = value => this.props.setDescription(value)
  
  handleDriftHelpDomainChange = event => this.props.setDriftHelpDomain(event.target.value)
  
  handleCnameDomainChange = event => this.props.setCnameDomain(event.target.value)
  
  render() {
    const { settings } = this.props
    return (
      <div className="basic-settings-wrapper">
        <fieldset>
          <Input
            label="Help Center Title"
            description="This is the title of your help center"
            value={settings.title}
            onChange={this.handleTitleChange}
          />
          <Input
            label="Tagline"
            description="Welcome your visitors with a friendly message"
            value={settings.tagline}
            onChange={this.handleTaglineChange}
          />
        </fieldset>
  
        <TextArea
          label="Meta Description"
          description="This description will be displayed when someone looks for your help center on a search engine (e.g. Google)"
          text={settings.description}
          onChange={this.handleDescriptionChange}
        />
  
        <fieldset>
          <DriftHelpDomainInput
            value={settings.driftHelpDomain}
            onChange={this.handleDriftHelpDomainChange}
          />
    
          <Input
            label="Custom Domain"
            description="Enter the CNAME from your server here"
            value={settings.cnameDomain}
            placeholder={"e.g. dundermifflin.docs.com"}
            onChange={this.handleCnameDomainChange}
          />
        </fieldset>
        
        <CustomLinks/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: selectors.getSettings(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setTitle: actions.setTitle,
    setTagline: actions.setTagline,
    setDescription: actions.setDescription,
    setDriftHelpDomain: actions.setDriftHelpDomain,
    setCnameDomain: actions.setCnameDomain
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(BasicSettings)